<template>
  <div>
    <a-collapse defaultActiveKey="1" v-model="activeKey">
      <a-collapse-panel header="Pencarian Pengiriman" key="1">
        <filter-panel @closePanel="closePanel"/>
      </a-collapse-panel>
    </a-collapse>

    <ShipmentTable v-if="showTable"/>
  </div>
</template>

<script>
import ShipmentTable from "@/components/shipment/ShipmentTable.vue";
import FilterPanel from "@/components/shipment/FilterPanel";

export default {
  components: {
    ShipmentTable,
    FilterPanel
  },
  data() {
    return {
      showTable: false,
      activeKey: ["1"]
    };
  },
  methods: {
    closePanel() {
      // eslint-disable-next-line no-console
      this.activeKey = [];
      this.showTable = true;
    }
  }
};
</script>

<style >
.ant-collapse-header {
  font-weight: 600;
}
</style>